module.exports = __webpack_public_path__ + "media/icon/icon-car-green-4483eba5.svg";